.picker {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
  align-items: center;
}

.modeGroup {
  display: inline-flex;
  gap: 4px;
  flex-wrap: wrap;
}

.modeButton {
  padding: 4px var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-default);
  background: transparent;
  cursor: pointer;
  border-radius: var(--tuna-shape-borderRadius);
  min-height: 44px;
}

.modeButtonActive {
  composes: modeButton;
  border-color: var(--tuna-palette-primary-main);
  background: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
}

.tonicLabel {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.tonicSelect {
  min-height: 44px;
  padding: 4px var(--tuna-spacing-1);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: transparent;
}
